import { createContext, useContext } from 'react';

const _LinkBehaviorContext = createContext(undefined);
/**
 * Introduce click behavior override for all links. This can be used to inject handling for special
 * cases, like when Figma is rendered inside of vscode. In that case we have to post a message to
 * the parent page as regular links don't work.
 *
 * @example
 *
 * ```tsx
 * <FplSettings.LinkBehaviorContext
 *   value={(e) => {
 *     const href = e.currentTarget.href
 *     if (shouldHandleLink(href)) {
 *       e.preventDefault()
 *       handleLink(href)
 *     }
 *   }}
 * >
 *   {children}
 * </FplSettings.LinkBehaviorContext>
 * ```
 */
const LinkBehaviorContext = _LinkBehaviorContext.Provider;
/** Get the link behavior passed in via FplSettings.LinkBehaviorContext. */
function useLinkBehavior() {
    return useContext(_LinkBehaviorContext);
}

export { LinkBehaviorContext, useLinkBehavior };
//# sourceMappingURL=settings.link-behavior.js.map
